module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"b":"Votre adresse email est vérifée","d":"Suivant"},"en":{"b":"Your email address is verified","d":"Next"}}')
  delete Component.options._Ctor
}
